import { css } from "../../../component-styles";

/** Minimal spacing — only sets --max-width for alignment. */
export const minimal = css`
  :host {
    --max-width: 840px;
  }
`;
